import { Component, Input } from "@angular/core";
import { LeaderboardDTO } from "src/app/data/schema/Gamification/Leaderboard/LeaderboardDTO";

@Component({
    selector: "app-leaderboard-podium",
    templateUrl: "./leaderboard-podium.component.html",
    styleUrls: ["./leaderboard-podium.component.scss"]
})
export class LeaderboardPodiumComponent {
    @Input() leaders: LeaderboardDTO[];

    first(): LeaderboardDTO {
        return this.leaders[0];
    }

    second(): LeaderboardDTO {
        return this.leaders[1];
    }

    third(): LeaderboardDTO {
        return this.leaders[2];
    }
}
